import {Component, Input, signal, WritableSignal} from '@angular/core';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';

@Component({
  selector: 'app-staff-access-password-reset-link-modal',
  templateUrl: './staff-access-password-reset-link-modal.component.html',
  styleUrls: ['./staff-access-password-reset-link-modal.component.scss'],
  standalone: false,
})
export class StaffAccessPasswordResetLinkModalComponent {
  @Input() email = '';
  @Input() emailSent = false;
  @Input() passwordResetLink = '';

  protected readonly copyFailed: WritableSignal<boolean> = signal(false);
  protected readonly hasCopied: WritableSignal<boolean> = signal(false);
  protected readonly iconColourEnum = IconColourEnum;
  protected readonly icons = IconsEnum;
  protected readonly isCopying: WritableSignal<boolean> = signal(false);

  constructor(private readonly modalController: ModalControllerService) {}

  protected async onCopyPasswordResetLinkClick(): Promise<void> {
    if (!this.passwordResetLink || this.isCopying()) {
      return;
    }

    this.isCopying.set(true);
    try {
      await navigator.clipboard.writeText(this.passwordResetLink);
      this.hasCopied.set(true);
      this.copyFailed.set(false);
    } catch {
      this.copyFailed.set(true);
    } finally {
      this.isCopying.set(false);
    }
  }

  protected async onContinue(): Promise<void> {
    await this.modalController.dismiss();
  }
}
